import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { LockSettingService } from '@core/services/lock-setting.service';
import { AddEditLockingStatusComponent } from './add-edit-locking-status/add-edit-locking-status.component';
import { ToastService } from '@core/services/toast.service';
import { ILockingStatus } from '@core/interfaces/ilockingstatus';
import { AnySchema } from 'ajv';
import { AddEditComponent } from '@shared/components/drdp-tables/add-edit/add-edit.component';
import { IModalEmitData } from '@core/interfaces/imodal';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-locking-status',
    templateUrl: './locking-status.component.html',
    styleUrls: ['./locking-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LockingStatusComponent implements OnInit {
  @ViewChild(AddEditComponent) table?: AddEditComponent;
  isSuperUser: boolean = true;
  tableData: any[] = [];
  dataSource: MatTableDataSource<AnySchema> = new MatTableDataSource();
  formTableColumns: any[] = [];

  constructor(private lockSetting : LockSettingService,
              public modal: MatDialog,
              public toast: ToastService,
              private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.formTableColumns = [
      { columnDef: 'lockType', header: this.translocoService.translate('configuration.lockingStatus.columns.lockType'), type: 'text'},
      { columnDef: 'lockDate', header: this.translocoService.translate('configuration.lockingStatus.columns.lockDate'), type: 'date'},
      { columnDef: 'isActive', header: this.translocoService.translate('configuration.common.active'), type: 'text'}
    ];
    if (this.isSuperUser) {
      this.formTableColumns.push({ columnDef: 'edit', header: this.translocoService.translate('configuration.common.edit'), type: 'edit' });
    }
    this.lockSetting.getAllLockSettings().subscribe((res) => {
      res = res.map((s : any) => ({...s, isActive: s.active ? this.translocoService.translate('configuration.common.yes') : this.translocoService.translate('configuration.common.no')}));
      this.dataSource.data = res;
      this.tableData = res;
    })
  }

  openModal(data?: IModalEmitData): void {
    const modalRef = this.modal.open(AddEditLockingStatusComponent, {data: data ? data.data : undefined});

    modalRef.afterClosed().subscribe((res: any) => {
      if (data && res.formValid) {
        this.lockSetting.updateLockSetting(res.payload).subscribe((success) => {
          if (success) {
            this.tableData[data.index] = res.updateTableView;
            this.tableData[data.index].isActive = this.tableData[data.index].active ? this.translocoService.translate('configuration.common.yes') : this.translocoService.translate('configuration.common.no');
            this.table?.reRender(this.tableData);
            this.toast.success(this.translocoService.translate('configuration.lockingStatus.updatedToast'));
          } else {
            this.toast.success(this.translocoService.translate('configuration.lockingStatus.updateFailedToast'));
          }
        })
      }
    })
  }

}
